// Example: pages/Signup.js
import { useAuth } from "../context/AuthContext";
import { useState } from "react";

function Signup() {
  const { signUp } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [smsOptIn, setSmsOptIn] = useState(false);

  const handleSignup = async () => {
    try {
      await signUp(email, password, smsOptIn);
      alert("Signed up successfully!");
    } catch (error) {
      console.error("Sign Up Error:", error);
    }
  };

  return (
    <div>
      <h2>Sign Up</h2>
      <input
        type="email"
        placeholder="Email"
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        onChange={(e) => setPassword(e.target.value)}
      />
      <div>
        <input
          type="checkbox"
          id="smsOptIn"
          checked={smsOptIn}
          onChange={() => setSmsOptIn(!smsOptIn)}
        />
        <label htmlFor="smsOptIn">
          I agree to receive SMS notifications. Message & data rates may apply.
          <a href="/Privacy" target="_blank"> Privacy Policy</a>
        </label>
      </div>
      <button onClick={handleSignup}>Sign Up</button>
    </div>
  );
}

export default Signup;
